angular.module('qkr').filter('taxRateToPercentage', ['utils', function(utils) {
    return function(taxRate) {
        const numOfDecimalPlaces = utils.getNumberOfDecimalPlaces(taxRate);
        if (numOfDecimalPlaces > 5) {
            return 'Error';
        } else {
            return (taxRate * 100).toFixed(numOfDecimalPlaces) + '%';
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/filters/tax_rate_to_percentage.js